var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ProgressBar"},[_c('div',{staticClass:"ProgressBar-filledBar",style:({ transform: ("translate3d(-" + ((1 - _vm.progress) * 100) + "%, 0, 0)") })})])}
var staticRenderFns = []

export { render, staticRenderFns }